import React, { useEffect } from 'react';

export default function TrustpilotWidget() {
  useEffect(() => {
    // Load Trustpilot widget script
    const script = document.createElement('script');
    script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div 
      className="trustpilot-widget my-8 flex justify-center" 
      data-locale="en-GB"
      data-template-id="53aa8807dec7e10d38f59f32"
      data-businessunit-id="690a6d83154aa52f830e5107"
      data-style-height="150px"
      data-style-width="100%"
      data-theme="light"
      data-stars="4,5"
      data-schema-type="Organization"
    >
      <a 
        href="https://uk.trustpilot.com/review/myeaitradingcompass.com" 
        target="_blank" 
        rel="noopener noreferrer"
        className="text-[#337AF7] hover:text-[#162959] transition-colors"
      >
        Trustpilot
      </a>
    </div>
  );
}
